import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
	meta:{
	  title:'华智微官网'
	}
  },
  {
    path: '/usercenter',
    name: 'usercenter',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/usercenter.vue'),
	meta:{
	  title:'会员中心'
	}
  },
  {
    path: '/goods_detail',
    name: 'goods_detail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/goods_detail.vue'),
	meta:{
	  title:'课程详情'
	}
  },
  {
    path: '/course_list',
    name: 'course_list',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/course_list.vue'),
	meta:{
	  title:'我的课程'
	}
  },
  {
    path: '/privilege',
    name: 'privilege',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/privilege.vue'),
	meta:{
	  title:'会员特权'
	}
  },
  {
    path: '/position_search',
    name: 'position_search',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/position_search.vue'),
	meta:{
	  title:'上海公务员职位查询'
	}
  },
  {
    path: '/position_list',
    name: 'position_list',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/position_list.vue'),
	meta:{
	  title:'上海公务员职位查询'
	}
  },
  {
    path: '/position_detail',
    name: 'position_detail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/position_detail.vue'),
	meta:{
	  title:'职位查询结果'
	}
  },
  {
    path: '/order_list',
    name: 'order_list',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/order_list.vue'),
	meta:{
	  title:'订单列表'
	}
  },
  {
    path: '/course_detail',
    name: 'course_detail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/course_detail.vue'),
	meta:{
	  title:'课程播放'
	}
  },
  {
    path: '/live_detail',
    name: 'live_detail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/live_detail.vue'),
	meta:{
	  title:'直播课程'
	}
  },
  {
    path: '/live_replay',
    name: 'live_replay',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/live_replay.vue'),
	meta:{
	  title:'直播回放'
	}
  },
  {
    path: '/payment',
    name: 'payment',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/payment.vue'),
	meta:{
	  title:'支付中心'
	}
  },
  {
    path: '/docfile_list',
    name: 'docfile_list',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/docfile_list.vue'),
	meta:{
	  title:'课件下载'
	}
  },
  {
    path: '/coupon_list',
    name: 'coupon_list',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/coupon_list.vue'),
	meta:{
	  title:'我的卡券'
	}
  },
  {
    path: '/detail_page',
    name: 'detail_page',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/detail_page.vue'),
	meta:{
	  title:'拼团详情'
	}
  },
  {
    path: '/my_group',
    name: 'my_group',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/my_group.vue'),
	meta:{
	  title:'拼团中'
	}
  },
  {
    path: '/payment_group',
    name: 'payment_group',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/payment_group.vue'),
	meta:{
	  title:'立即支付'
	}
  },
  {
    path: '/group_detail',
    name: 'group_detail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/group_detail.vue'),
	meta:{
	  title:'拼团中详情'
	}
  },
  {
    path: '/all_evaluation',
    name: 'all_evaluation',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/all_evaluation.vue'),
	meta:{
	  title:'全部评价'
	}
  },
  {
    path: '/reset_password',
    name: 'reset_password',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/reset_password.vue'),
	meta:{
	  title:'密码找回'
	}
  },
  {
    path: '/auth',
    name: 'auth',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/auth.vue'),
	meta:{
	  title:'微信验证'
	}
  },
  {
    path: '/auth_new',
    name: 'auth_new',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/auth_new.vue'),
  	meta:{
  	  title:'微信验证'
  	}
  },
  {
    path: '/getauthcode',
    name: 'getauthcode',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/getauthcode.vue'),
  	meta:{
  	  title:'微信验证'
  	}
  },
  {
    path: '/auth_binding',
    name: 'auth_binding',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/auth_binding.vue'),
	meta:{
	  title:'微信账号绑定'
	}
  },
  {
    path: '/group_booking',
    name: 'group_booking',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/group_booking.vue'),
	meta:{
	  title:'拼团'
	}
  },
  {
    path: '/shiting',
    name: 'shiting',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/shiting.vue'),
	meta:{
	  title:'课程试听'
	}
  },
  {
    path: '/course_search',
    name: 'course_search',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/course_search.vue'),
	meta:{
	  title:'课程搜索'
	}
  },
  {
    path: '/positioncontrast',
    name: 'positioncontrast',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/positioncontrast.vue'),
	meta:{
	  title:'职位竞争比'
	}
  },
  {
    path: '/positiondetails',
    name: 'positiondetails',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/positiondetails.vue'),
	meta:{
	  title:'职位详情'
	}
  },
  {
    path: '/jobbank',
    name: 'jobbank',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/jobbank.vue'),
	meta:{
	  title:'职位查询'
	}
  },
  {
    path: '/interviewlist',
    name: 'interviewlist',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/interviewlist.vue'),
	meta:{
	  title:'面试名单'
	}
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
